import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { MIDDLE_MARGIN } from '../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: MIDDLE_MARGIN,
      [theme.breakpoints.up('md')]: {
        marginBottom: 0,
        flexDirection: 'row',
      },
    },
    iconWrapper: {
      position: 'absolute',
      width: 80,
      height: 80,
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 5,
      [theme.breakpoints.up('sm')]: {
        borderRadius: '50%',
        background: 'rgba(29, 29, 41, 0.501961)',
      },
    },
  }),
);
export default useStyles;
